import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, InvoicesDialogueHandler } from '../types';
import InvoicesDialogueContext from './InvoicesContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type DeleteBankAccountDialogueProps = {
  handleDialogue: DialogueHandler<InvoicesDialogueHandler>;
};

type FC = FunctionComponent<DeleteBankAccountDialogueProps>;

const InvoicesDialogue: FC = ({ handleDialogue }: DeleteBankAccountDialogueProps) => {
  const { showDownloadErrorAlert } = useContext(InvoicesDialogueContext);
  const { t } = useTranslation('translations', {
    keyPrefix: 'Accounts.AccountAndBilling.InvoicesAndStatements.InvoicesDialogue',
  });

  return useMemo(
    () => (
      <div>
        {/* Delete Bank Account Confirmation */}
        <ConfirmationDialogue
          isVisible={showDownloadErrorAlert}
          title={t('title')}
          status="alert"
          subTitle={t('subTitle')}
          confirm={{
            label: t('confirmButton'),
            action: () => handleDialogue({ type: 'confirm', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showDownloadErrorAlert],
  );
};

export default InvoicesDialogue;
